"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.89,11.18a.79.79,0,0,0,.08-.26,1.32,1.32,0,0,0,0-.56.79.79,0,0,0-.08-.26,1.37,1.37,0,0,0-.31-.48L19.33,5.36,19,5.06a1.81,1.81,0,0,0-.23-.18A1.43,1.43,0,0,0,18,4.64a1.39,1.39,0,0,0-.79.24,1.24,1.24,0,0,0-.18.14.1.1,0,0,1-.05,0,1.49,1.49,0,0,0-.32.48,1.47,1.47,0,0,0,0,1.09,1.61,1.61,0,0,0,.32.48l1.44,1.44.64.65H10.93a1.44,1.44,0,0,0,0,2.88h8.15L17,14.18a1.41,1.41,0,0,0-.32,1.56,1.49,1.49,0,0,0,.32.48,1.3,1.3,0,0,0,.23.18,1.39,1.39,0,0,0,.79.24h0a1.43,1.43,0,0,0,.5-.09,1.78,1.78,0,0,0,.45-.28l.07-.05,2.29-2.3,2.25-2.26A1.37,1.37,0,0,0,23.89,11.18Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18,17.55a2.36,2.36,0,0,1-1.29-.39,2.2,2.2,0,0,1-.37-.3,2.33,2.33,0,0,1,0-3.32L16.9,13h-6a2.35,2.35,0,0,1,0-4.7h6l-.54-.55A2.38,2.38,0,0,1,15.84,7a2.35,2.35,0,0,1,.52-2.55l.11-.09a2.65,2.65,0,0,1,.26-.21A2.28,2.28,0,0,1,19,4V1.76a.51.51,0,0,0-.58-.58H.58A.51.51,0,0,0,0,1.76V19.59a.51.51,0,0,0,.58.58H6.42l2.92,2.88a.28.28,0,0,0,.15.06.23.23,0,0,0,.15-.06l2.93-2.88h5.84a.51.51,0,0,0,.58-.58V17.32l-.15.07A2.3,2.3,0,0,1,18,17.55Z"
  }));
};

exports["default"] = _default;